<template>
  <div
    v-if="variant === 'legacy'"
    class="py-0 pr-0 auth-layout-legacy"
    data-testid="auth-layout-legacy"
  >
    <div class="auth-layout-legacy__page user-login-form d-flex justify-space-between">
      <div class="auth-layout-legacy__form flex-grow-1 px-12">
        <slot />
      </div>
      <div
        v-if="$vuetify.breakpoint.mdAndUp"
        class="auth-layout-legacy__photo flex-shrink-1 d-lg-flex justify-end"
      >
        <img class="auth-layout-legacy__image" :src="legacyPhoto" alt="" />
      </div>
    </div>
  </div>

  <div v-else-if="variant === 'split'" class="auth-layout-split" data-testid="auth-layout-split">
    <div class="auth-layout-split__form-side">
      <img class="auth-layout-split__logo" :src="logo" alt="exIQtive" />
      <div class="auth-layout-split__form">
        <div class="auth-layout-split__column">
          <slot />
        </div>
      </div>
    </div>
    <PromoPanel class="auth-layout-split__promo" />
  </div>

  <div v-else class="auth-layout-card" data-testid="auth-layout-card">
    <div class="auth-layout-card__card" :class="{ 'auth-layout-card__card--wide': wide }">
      <img v-if="showLogo" class="auth-layout-card__logo" :src="logo" alt="exIQtive" />
      <slot />
    </div>
  </div>
</template>

<script setup>
import PromoPanel from "@components/PromoPanel/PromoPanel.vue";
import logo from "@components/assets/login/exiqtive-wordmark.svg";

defineProps({
  variant: {
    type: String,
    default: "split",
    validator: (value) => ["legacy", "split", "card"].includes(value),
  },
  wide: { type: Boolean, default: false },
  showLogo: { type: Boolean, default: true },
});

const legacyPhoto = require("@/assets/login/Section1.png");
</script>

<style scoped>
.auth-layout-legacy {
  width: 100%;
  max-width: 1600px;
}
.auth-layout-legacy__page {
  height: 100%;
  width: 100%;
  background: #ffffff;
  margin: 0;
}
.auth-layout-legacy__form {
  padding: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.auth-layout-legacy__photo {
  padding: 0;
}
.auth-layout-legacy__image {
  height: 100vh;
  max-width: 100%;
  object-fit: contain;
}

.auth-layout-split {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
}
.auth-layout-split__form-side {
  display: flex;
  flex: 1 1 50%;
  flex-direction: column;
  min-width: 0;
}
.auth-layout-split__logo {
  align-self: flex-start;
  width: 309px;
  max-width: calc(100% - 48px);
  height: auto;
  margin: 56px 0 0 64px;
}
.auth-layout-split__form {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
}
.auth-layout-split__column {
  width: 100%;
  max-width: 400px;
}
.auth-layout-split__promo {
  flex: 0 0 50%;
}

.auth-layout-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  padding: 24px;
  box-sizing: border-box;
  background-color: #f9fafb;
}
.auth-layout-card__card {
  box-sizing: border-box;
  width: 100%;
  max-width: 440px;
  padding: 40px;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  background-color: #ffffff;
}
.auth-layout-card__card--wide {
  max-width: 480px;
}
.auth-layout-card__logo {
  display: block;
  width: 154px;
  max-width: 100%;
  height: auto;
  margin: 0 0 32px;
}

@media (max-width: 959px) {
  .auth-layout-split__logo {
    margin: 24px 0 0 24px;
  }
}
@media (max-width: 599px) {
  .auth-layout-card__card {
    padding: 24px;
  }
}
</style>
